'use client';

import { Tab, tabTag } from '@ni/nimble-components/dist/esm/tab';
import { wrap } from '../utilities/react-wrapper';

export { tabTag };
export { type Tab };
export const NimbleTab = wrap(Tab);
